import React from 'react'
import { TFunction } from 'i18next'
import { CustomTextArea, CustomTextInput } from 'src/components'

interface FormProps {
  name: string,
  placeholder?: string,
  required: boolean
}

interface CompleteInfoSection {
  labelProps: { label: string }
  childLabel: string,
  formComponent: React.FunctionComponent<any>
  formProps: FormProps
}

export const getCompleteInfoFormSections = (t: TFunction): CompleteInfoSection[] => [

  { // Reason to register
    labelProps: { label: t('Auth.CompleteInfo.Reason') },
    childLabel: t('Auth.CompleteInfo.ReasonLabel'),
    formComponent: CustomTextArea,
    formProps: {
      name: 'reasonToRegister',
      placeholder: t('Auth.CompleteInfo.ReasonPlaceholder'),
      required: true
    }
  },

  { // Company Position
    labelProps: { label: t('Auth.CompleteInfo.CompanyPosition') },
    childLabel: t('Auth.CompleteInfo.CompanyPositionLabel'),
    formComponent: CustomTextInput,
    formProps: {
      name: 'companyPosition',
      placeholder: t('Auth.CompleteInfo.CompanyPositionPlaceholder'),
      required: true
    }
  },
]
